// imports
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';

// local imports
import usgsLogo from '../../assets/uswds/usgsLogo.png';
import { USGS_BLUE } from '../../constants/colors';

export default function USGSHeader() {
  return (
    <AppBar
      id="usgsHeader"
      component="div"
      aria-label="usgs header"
      sx={{
        backgroundColor: USGS_BLUE,
        position: 'static',
        boxShadow: 'none',
        overflow: 'hidden',
        flexShrink: 1,
        height: '48px',
        '@media (min-width:1024px)': {
          height: '85px',
        },
      }}
    >
      <Toolbar
        disableGutters
        sx={{
          height: '48px',
          minHeight: '48px !important',
          padding: 0,
          boxShadow: 'none',

          '@media (min-width:1024px)': {
            height: '85px',
            minHeight: '85px !important',
          },
        }}
      >
        <Box
          sx={{
            width: '100%',
            maxWidth: '1024px',
            margin: '0 auto',
            paddingLeft: 0,
            paddingRight: 0,
            display: 'flex',
            alignItems: 'center',
            '@media (min-width:1024px)': {
              paddingLeft: '25px',
              paddingRight: '32px',
            },
          }}
        >
          <a
            href="https://www.usgs.gov"
            aria-label="USGS.gov"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Box
              component="img"
              src={usgsLogo}
              alt="USGS Logo"
              width={113}
              height={39}
              sx={{
                height: '39px',
                width: 'auto',
                display: 'block',
                '@media (max-width:899px)': {
                  paddingLeft: '16px',
                  paddingBottom: '2px',
                  paddingTop: '1px',
                },
                '@media (min-width:900px) and (max-width:1023px)': {
                  paddingLeft: '25px',
                  paddingBottom: '2px',
                  paddingTop: '1px',
                },
                '@media (min-width:1024px)': {
                  height: '2.95em',
                },
              }}
            />
          </a>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
